//#region src/quick_add_eligibility.ts
let QuickAddEligibility = /* @__PURE__ */ function(QuickAddEligibility) {
	QuickAddEligibility["HasNoModGroups"] = "has-no-mod-groups";
	QuickAddEligibility["HasModGroupsNoRequiredChoices"] = "has-mod-groups-no-required-choices";
	QuickAddEligibility["AllRequiredModGroupsArePreselected"] = "has-required-mod-groups-are-preselected";
	return QuickAddEligibility;
}({});
//#endregion
export { QuickAddEligibility };

//# sourceMappingURL=quick_add_eligibility.js.map